import type { CategoryDto } from '@entities/product';
import { haptics } from '@shared/lib/telegram';
import { AnimatedTabs } from '@shared/ui/AnimatedTabs';
import styles from './CategoryTabs.module.css';

export interface CategoryTabsProps {
  categories: readonly CategoryDto[];
  /** An empty value selects all products, matching the storefront URL filters. */
  value: string;
  onChange: (categoryId: string) => void;
  loading?: boolean;
  ariaLabel?: string;
  /** Applied to the surrounding layout container, never to the shared tab rail. */
  className?: string;
}

/** Catalog labels around the same animated tab control used throughout YeneShop. */
export function CategoryTabs({ categories, value, onChange, loading = false, ariaLabel = 'Product categories', className }: CategoryTabsProps) {
  return <div className={[styles.container, className].filter(Boolean).join(' ')}>
    <AnimatedTabs
      items={[{ id: '', label: 'All products' }, ...categories.map(category => ({ id: category.id, label: category.name }))]}
      value={value}
      onChange={onChange}
      onSelectionFeedback={haptics.select}
      ariaLabel={ariaLabel}
    />
    {loading && <p className={styles.loading} role="status">Loading categories…</p>}
  </div>;
}
